"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESenderType = exports.ESendCodeStatus = void 0;
let ESenderType = exports.ESenderType = /*#__PURE__*/function (ESenderType) {
  /** SMS **/
  ESenderType["Sms"] = "sms";
  /** Звонок **/
  ESenderType["Call"] = "call";
  return ESenderType;
}({});
let ESendCodeStatus = exports.ESendCodeStatus = /*#__PURE__*/function (ESendCodeStatus) {
  ESendCodeStatus["Succeed"] = "succeed";
  ESendCodeStatus["Failed"] = "failed";
  return ESendCodeStatus;
}({});